import React, { Component } from 'react';
import { connect } from 'react-redux';

import Sticky from 'Components/Sticky';
import ActionLoader from 'Components/ActionLoader';
import { GET_HOLISTICS, GET_HOLISTICS_TOKEN } from 'Constants/actionConstants';
import { CARGIL, CENTURY_PLY, ROQUETTE, DALMIA_CEMENT } from 'Constants/commonConstants';
import { isAdaniWilmar } from 'Utils/';
import { getUser } from 'Utils/storage'
import ScreenTimeTrack from "Components/Common/ScreenTimeTrack/index";
import { screenInfoDetails } from 'Constants/screenInfoDetailsConstants';

class Holistics extends Component {
    state = {
        isLoading: true
    }

    showReport = () => {
        const { embedCode, token } = this.props;
        return(
        <>
        { this.state.isLoading && <ActionLoader /> }
        {token &&
            <iframe
                src={"https://secure.holistics.io/embed/" + embedCode + "?_token=" + token}
                style={{ width: "100%", height: 600 }}
                frameBorder="0"
                onLoad={() => { this.setState({ isLoading: false }) }}
                title="Holistics"
                allowFullScreen>
            </iframe>
        }
        </>
        )
    }

    render() {
        return (
            <>
                <ScreenTimeTrack
                    screenInfoDetailsItem={
                        screenInfoDetails.CONTRACTING_MIS_REPORT_SCREEN
                    }
                />
            {!isAdaniWilmar() ? <Sticky> {this.showReport()} </Sticky>
            : <> {this.showReport()} </>
            }
            </>
        );
    }
    componentDidMount() {
        const { dispatch } = this.props;
        const user = getUser();
        const isCargil = CARGIL.includes(user.companyId);
        const isRoquette = ROQUETTE.includes(user.companyId);
        const isCenturyPly = CENTURY_PLY.includes(user.companyId);
        const isDalmia = DALMIA_CEMENT.includes(user.companyId);
        dispatch({
            type: (isRoquette || isCargil || isCenturyPly || isDalmia) ? GET_HOLISTICS_TOKEN : GET_HOLISTICS,
            params: (isCargil || isRoquette || isCenturyPly || isDalmia) ? {
                type: isRoquette ? 51 : (isCenturyPly ? 59 : (isDalmia ? 66 : 30)),
                companyId: user.companyId
            } : {}
        })
    }
}

const mapStateToProps = ({constants}) => {
  return {
    token: constants.holistics.token,
    embedCode: constants.holistics.embedCode,
  }
};


export default connect(mapStateToProps)(Holistics);
